import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/seance-actions';
import { SeanceActions } from '../constants';
import { ISeance, ISeanceStatistics } from 'src/types/seance';

export interface SeanceListState {
    inProgress: boolean;
    inProgressCSV: boolean;
    authCode: string;
    error: string;
    data: Paginated<ISeance>;
    unconfirmed: any[];
    current: ISeance | null;
    miniLoaderFor: { [key: string]: boolean };
    statistics: ISeanceStatistics | null;
    currentFiles: any | null;
    copySeance: ISeance | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    statistics: null,
    inProgressCSV: false,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    unconfirmed: [],
    miniLoaderFor: {},
    current: null,
    currentFiles: null,
    copySeance: null,
};

export function seancesList(state: SeanceListState = initialState, action: Actions | any): SeanceListState {
    switch (action.type) {
        case requestType(SeanceActions.FETCH_SEANCES_LIST):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    totalPages: undefined,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(SeanceActions.FETCH_SEANCES_LIST):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(SeanceActions.FETCH_SEANCES_LIST):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };
        default:
            return state;
    }
}
